import { useContext } from 'react'
import localeContext from '../../i18n/locale-context'

export default function useI18n() {
  const context = useContext(localeContext)
  return context
}
